import { Injectable } from "@angular/core";
import { LogUpload } from "../utils/log-upload";
import { TrsEventsService } from "./trsevents.service";

@Injectable()
export class EventFilterService {
    logUploader: LogUpload = new LogUpload("EventFilterService");

    private uniqueViolationsRequestInterval: NodeJS.Timeout;
    private uniqueViolations: Set<string> = new Set<string>();

    constructor(private trsService: TrsEventsService) {
        this.trsService.evtdata.subscribe((response) => {
            switch (response.eventName) {
                case "GETUNIQUEVIOLATIONNAMES":
                    this.handleUniqueViolationsResponse(response.data);
                    break;
                default:
                    break;
            }
        });
    }

    public startEventFilterMonitor = (): void => {
        this.trsService.evtdata.next({
            "eventName": "UNIQUE_VIOLATIONS_REQUEST",
            "data": "",
        });
        this.uniqueViolationsRequestInterval = setInterval(() => {
            this.trsService.evtdata.next({
                "eventName": "UNIQUE_VIOLATIONS_REQUEST",
                "data": "",
            });
        }, 60000);
    }

    public stopEventFilterMonitor = (): void => {
        if (this.uniqueViolationsRequestInterval != null)
            clearInterval(this.uniqueViolationsRequestInterval);

        this.uniqueViolations = new Set<string>();
    }

    private handleUniqueViolationsResponse = (data: string[]): void => {
        if (data != null && data.length > 0) {
            this.uniqueViolations.clear();

            const sortedData: string[] = data.sort();

            sortedData.forEach((info: string): void => {
                if (this.uniqueViolations.has(info) === false)
                    this.uniqueViolations.add(info);
            });

            this.trsService.evtdata.next({
                "eventName": "UPDATE_EVENT_FILTER",
                "data": ""
            });
        }
    }

    public getUniqueViolations = (): Set<string> => this.uniqueViolations;
}